import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.keys.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { LoadListFields, SaveListFields as _SaveListFields, DeleteFields, GetIntiTableColumnList } from '@/api/ListParam';
import { mapGetters } from 'vuex';
export default {
  name: 'SeniorColumn',
  props: {
    data: {
      type: Array
    }
  },
  data: function data() {
    return {
      radioFlage: false,
      prefix: '',
      seniorColumnDrawer: false,
      loading: false,
      mainTable: [],
      mainKeys: [],
      // 主表字段所有列
      validRules: {
        ORD_IDX: [{
          required: true,
          message: '请输入序号'
        }],
        FIELD_NAME: [{
          required: true,
          message: '请选择字段名称'
        }],
        FIELD_CAPTION: [{
          required: true,
          message: '请输入字段标题'
        }]
      }
    };
  },
  computed: _objectSpread({}, mapGetters(['userinfo'])),
  methods: {
    handlePrefix: function handlePrefix() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.prefix) {
                  _context.next = 7;
                  break;
                }

                _this.loading = true;
                _context.next = 4;
                return GetIntiTableColumnList({
                  table_name: _this.prefix
                }).catch(function (_) {
                  _this.loading = false;
                });

              case 4:
                res = _context.sent;
                _this.loading = false;

                if (res.Result) {
                  data = res.Result || []; // const $table = this.$refs.xTable
                  // const { fullData } = $table.getTableData()
                  // if (fullData.length <= 0) {
                  //   data.map((item, index) => {
                  //     const record = {
                  //       ORD_IDX: index + 1,
                  //       FIELD_NAME: item.COLUMN_NAME,
                  //       FIELD_CAPTION: item.COLUMN_CAPTION,
                  //       FIELD_WIDTH: '140',
                  //       IS_VISIBLE: 'Y',
                  //       USER_NAME: this.userinfo.USER_NAME
                  //     }
                  //     $table.insertAt(record, -1)
                  //   })
                  // }

                  _this.mainTable.map(function (mt) {
                    data.map(function (item, index) {
                      if (item.COLUMN_NAME.toCamel() === mt.FIELD_NAME) {
                        // 字段标题补充
                        if (!_this.radioFlage) {
                          if (mt.FIELD_CAPTION === '' || mt.FIELD_CAPTION == null || mt.FIELD_CAPTION === undefined) {
                            mt.FIELD_CAPTION = item.COLUMN_CAPTION;
                          }
                        } else {
                          mt.FIELD_CAPTION = item.COLUMN_CAPTION;
                        }
                      }
                    });
                  });
                } else {
                  _this.$message.warning(res.ErrorInfo.Message);
                }

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 全部删除
    seniorColumnDeleteAll: function seniorColumnDeleteAll(flag) {
      var _this2 = this;

      var $table = this.$refs.xTable;

      var _$table$getTableData = $table.getTableData(),
          fullData = _$table$getTableData.fullData;

      if (fullData && fullData.length <= 0) return;
      this.$confirm('此操作将全部删除表格配置列, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var tempData, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                tempData = fullData[0];

                if (flag) {
                  tempData.USER_NAME = undefined;
                } else {
                  tempData.USER_NAME = _this2.userinfo.USER_NAME;
                }

                _context2.next = 4;
                return DeleteFields(tempData);

              case 4:
                res = _context2.sent;

                if (!res.Result) {
                  _context2.next = 9;
                  break;
                }

                _this2.seniorColumnDrawer = false;

                _this2.$emit('SeniorColumn', res.Result);

                return _context2.abrupt("return", _this2.$notify({
                  title: '成功',
                  message: '删除成功',
                  type: 'success'
                }));

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))).catch(function () {});
    },
    seniorColumnSave: function seniorColumnSave() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var $table, errMap, _$table$getTableData2, fullData;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                $table = _this3.$refs.xTable;
                _context3.next = 3;
                return $table.validate(true).catch(function (errMap) {
                  return errMap;
                });

              case 3:
                errMap = _context3.sent;

                if (errMap) {
                  _context3.next = 9;
                  break;
                }

                _$table$getTableData2 = $table.getTableData(), fullData = _$table$getTableData2.fullData;

                if (!(fullData && fullData.length <= 0)) {
                  _context3.next = 8;
                  break;
                }

                return _context3.abrupt("return");

              case 8:
                _this3.SaveListFields(fullData);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    SaveListFields: function SaveListFields(data) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var loading, res, collectColumn, collectColumns;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                loading = _this4.$loading({
                  lock: true,
                  text: 'Loading',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
                });
                _context4.next = 3;
                return _SaveListFields(data).catch(function (_) {
                  loading.close();
                });

              case 3:
                res = _context4.sent;
                loading.close();

                if (res.Result) {
                  _this4.seniorColumnDrawer = false;
                  _this4.radioFlage = false;

                  _this4.$notify({
                    title: '成功',
                    message: '保存成功',
                    type: 'success'
                  }); // 判断列是否隐藏


                  collectColumn = _this4.$parent.$refs.xTable.collectColumn; // 过滤

                  collectColumns = collectColumn.filter(function (i) {
                    return i.property;
                  });
                  collectColumns && collectColumns.map(function (item, index) {
                    if (data[index] && data[index].FIELD_NAME) {
                      if (data[index].FIELD_NAME === item.property) {
                        item.visible = data[index].IS_VISIBLE === 'Y';
                      }
                    }
                  });

                  _this4.$emit('SeniorColumn', res.Result);
                }

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 新增字段
    seniorColumngAdd: function seniorColumngAdd() {
      var $table = this.$refs.xTable;

      var _$table$getTableData3 = $table.getTableData(),
          fullData = _$table$getTableData3.fullData;

      var maxIndex = Math.max.apply(Math, fullData.length <= 0 ? [0] : fullData.map(function (o) {
        return o.ORD_IDX;
      })) + 1;
      var record = {
        ORD_IDX: maxIndex,
        FIELD_NAME: '',
        FIELD_CAPTION: '',
        FIELD_WIDTH: 140,
        IS_VISIBLE: 'Y',
        USER_NAME: this.userinfo.USER_NAME
      };
      $table.insertAt(record);
    },
    seniorColumnField: function seniorColumnField() {},
    handleSearchTableLoad: function handleSearchTableLoad() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res, TotalCount;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.seniorColumnDrawer = true;
                _this5.loading = true;

                _this5.handleMainTableKeys();

                _context5.next = 5;
                return LoadListFields({
                  USER_NAME: _this5.userinfo.USER_NAME
                }).catch(function (_) {
                  _this5.loading = false;
                });

              case 5:
                res = _context5.sent;
                _this5.loading = false;

                if (res.data) {
                  TotalCount = res.data.length;

                  if (TotalCount > 0) {
                    _this5.mainTable = res.data;
                  } else {
                    _this5.handleMaintableField();
                  }
                }

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    handleMaintableField: function handleMaintableField() {
      var _this6 = this;

      var $table = this.$refs.xTable;
      $table.loadData();
      this.mainKeys.map(function (item, index) {
        if (item.value) {
          var record = {
            ORD_IDX: index,
            FIELD_NAME: item.value,
            FIELD_CAPTION: '',
            FIELD_WIDTH: 140,
            IS_VISIBLE: 'Y',
            USER_NAME: _this6.userinfo.USER_NAME
          };
          $table.insertAt(record, -1);
        }
      });
    },
    // 获取字段名称列表
    handleMainTableKeys: function handleMainTableKeys() {
      console.log('获取字段名称列表', this.data);

      if (this.data && this.data.length > 0) {
        var blacklist = ['ID', '_XID', 'checked']; // 黑名单

        var data = this.data[0];
        var tempData = [{
          label: '',
          value: ''
        }];
        Object.keys(data).map(function (item) {
          if (blacklist.indexOf(item) === -1) {
            var obj = {};
            obj.label = item;
            obj.value = item;
            tempData.push(obj);
          }
        });
        this.mainKeys = tempData;
        console.log('mainKeys', this.mainKeys);
      }
    }
  }
};